// extracted by mini-css-extract-plugin
export default {"AppTitleContainer":"AppTitle-module__AppTitleContainer--Lpwx3","Heading":"AppTitle-module__Heading--K9xgc"};